jQuery(document).ready(function() {
    initNav();

    jQuery('.header-nav .burger').on('click', function () {
        jQuery('.nav-primary').slideToggle();
    });
});

jQuery(window).resize(function () {
    initNav();
});

function initNav () {
    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

    if (width <= 991) {
        jQuery('nav.nav-primary').css({
            display: 'none'
        });
    } else {
        jQuery('nav.nav-primary').css({
            display: 'block'
        });
    }
}
